export const SET_CHECK_IN_DATE = 'SET_CHECK_IN_DATE';
export const SET_CHECK_OUT_DATE = 'SET_CHECK_OUT_DATE';
export const SET_SEARCH_RESULTS = 'SET_SEARCH_RESULTS';
export const SET_SEARCH_LOCATION = 'SET_SEARCH_LOCATION';
export const SET_SHOW_MAP_ON_MOBILE = 'SET_SHOW_MAP_ON_MOBILE';
